import Service from "../Service";
const resource = "HmnDistributionControl/";

export default {
   
    pagination(dtr, requestID) {
        console.log("filter",dtr);
        return Service.post(resource + "listWorketActive", dtr, {
            params: { requestID: requestID },
        });
    },
    
};